export const cap36 = {
    DailyFee: '提前结清按照实际占用天数以每日最高0.1%单利IRR计算，最高不超过还款计划显示的息费总和。',
    TermFee: '提前结清按占用期数以每月最高3%单利IRR计算，最高不超过还款计划显示的息费总和。',
    PenaltyFee: '提前结清按实际占用天数计息，并收取剩余未还本金N%（N<=3）的违约金费用。',
    Default: '您是优质用户享提前结清优惠。优惠后息费按使用期数3%/月单利IRR计费，最高不超过还款计划显示的息费总和。',
    flexibleRepay: '提前结清按实际占用天数以每日最高capDailyRate单利IRR计算，最高不超过还款计划显示的息费总和。',
    preSettleDaily: '提前结清按照按照实际占用天数以每日最高0.1%单利IRR计算，最高不超过还款计划显示的息费总和'
}

export const ignoreRoute = [
    "/offlineRepay",
    "/result",
    "/middlePage",
    "/BindCardMiddlePage",
    "/BindCardResultPage",
    // "/creditCard",
    // "/creditCardRepayRecords",
    // "/creditCardRepayResult",
    // "/creditCardAdd",
    // "/creditCardRepay",
    // "/creditCardManage",
    "/repayInTime",
    "/protocol",
    "/patchSigning",
    "/offlineRepayGuide",
];

export const SERVICE_APPID = "1000003098";

export const DOMAIN_WHITE_LIST = [
    'https://*.baofoo.com/*',
    'https://*.ccb.com.cn/*',
    'https://*.boc.cn/*',
    'https://*.cgbchina.com.cn/*',
    'https://*.psbc.com/*',
    'https://*.abchina.com.cn/*',
    'https://*.pingan.com.cn/*',
    'https://*.bank.ecitic.com/*'
]

// export const DOMAIN_WHITE_MAP = {
//     "14": 'https://*.ccb.com.cn/*', // 建设银行
//     "13": 'https://*.boc.cn/*', // 中国银行
//     "4": 'https://*.cgbchina.com.cn/*', // 广发银行
//     "5": 'https://*.psbc.com/*', // 邮储银行
//     "16": 'https://*.abchina.com.cn/*', // 农业银行
//     "3": 'https://*.pingan.com.cn/*', // 平安银行
//     "11": 'https://*.bank.ecitic.com/*', // 中信银行
// }

export const LOAN_PROTOCOL_MAP = {
    wtdk: '//loancontract.ppdai.com/latest/agency/wtdk.html', // 委托代扣款协议
}

export const KOO_PROTOCOL_MAP = {
    wtdk: '//koouweb.koofenqi.com/web/static/protocol/autoRepayProtocol.html', // 委托代扣款协议
}

export const CHINESE_NUMS = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];

export const CLEAR_PLAN_TYPE_LIST = ['DailyFee', 'TermFee', 'PenaltyFee'];